// removed by extract-text-webpack-plugin
module.exports = {"value-row":"value-row__1xnTc","color":"color__3u42F"};


//////////////////
// WEBPACK FOOTER
// ./styles/plan/valueBreakup.scss
// module id = 746
// module chunks = 68